import $ from 'jquery';

import { Direction } from 'webapp/enums/enums';
import { TourDoneKey, TourId } from 'webapp/enums/tour';
import { TrackingEvent } from 'webapp/enums/tracking';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';
import { HiddenTourStep } from 'webapp/models-custom/tour/designer/option-hidden';

export default class DesignerAddToLoopDataboardTour extends TourBase {
	static keyForPersistantDone = TourDoneKey.DESIGNER__ADD_TO_LOOP;
	override trackEvent: TrackingEvent | '' = TrackingEvent.BUBBLES_DESIGNER_ADD_TO_LOOP;

	get id(): string {
		return TourId.DESIGNER__ADD_TO_LOOP;
	}

	override get keyForPersistantDone(): string {
		return DesignerAddToLoopDataboardTour.keyForPersistantDone;
	}

	override get stepData(): StepData[] {
		return [
			{
				direction: Direction.UP,
				allowStacked: true,
				attachTo: () => {
					return $('#loop-box .action-ct .single');
				},
			},
		];
	}

	override start(): void {
		super.start();
		this.markDone(); // just one step, once seen, it's done
	}

	override end(): void {
		super.end();
		this.flowTourDesignerService.resetHiddenTourExplicitlyClosedStatus(
			HiddenTourStep.BOARD_OPTIONS_HIDDEN,
		);
	}
}
